// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { RpcApiResponse } from '@interfaces/api.interfaces';
import { User, UserToken, UserTypes } from '@interfaces/user.interfaces';
import { Observable, catchError, map, of } from 'rxjs';
import { ApiService } from './api.service';
import { phoneExporter } from '../utils/form-utils';

@Injectable({
    providedIn: 'root',
})
export class TokenService {
    constructor(private readonly apiService: ApiService) {}

    sendSecureOneTimeUploadCode(dealerId: number, dealId: number, userToUploadDocuments: User, userType: UserTypes): Observable<UserToken> {
        return this.apiService
            .postV2$<UserToken>('api/deal/sendOneTimeUpload', {
                dealerId,
                dealId,
                userId: userToUploadDocuments.userId,
                email: userToUploadDocuments.email,
                phone: phoneExporter(userToUploadDocuments.phone),
                userType: userType,
                firstName: userToUploadDocuments.firstName,
                emailAlerts: userToUploadDocuments.emailAlerts,
                textAlerts: userToUploadDocuments.textAlerts,
            })
            .pipe(
                map((response) => {
                    return response?.data;
                })
            );
    }

    //ToDo: validateUploadToken is somehow called on recompile
    //Also has a value of "invalid" which is strange too
    validateSecureOneTimeCode(token: string): Observable<any> {
        return this.apiService.getV1$(`api/deal/validateUploadToken?encryptedToken=${token}`, undefined, false).pipe(
            catchError((err) => of({ data: { error: err, expired: true } })),
            map((response: RpcApiResponse<any>) => (response ? response.data : response))
        );
    }

    getSuccessMessage(whoWillAdd: 'customer' | 'dealer', requestType: 'documents' | 'license'): string {
        if (requestType === 'license') {
            return whoWillAdd === 'customer'
                ? 'Refresh the page to confirm the ID has been requested. Once the consumer has completed the steps to add their ID, the documents will move from the Documents Requested section to the Documents Added section in the Document Jacket.'
                : "Click on the link to take a picture of the customer's ID to add it to the Document Jacket. After you have completed the steps, the documents will move from the Documents Requested section to the Documents Added section in the Document Jacket.";
        } else {
            return whoWillAdd === 'customer'
                ? 'Refresh the page to confirm the documents have been requested. Once the customer has completed the steps to add the documents, they will move from the Documents Requested section to the Documents Added section in the Document Jacket.'
                : "Click on the link to take pictures of the customer's documents to add them to the Document Jacket. After you have completed the steps, the documents will move from the Documents Requested section to the Documents Added section in the Document Jacket.";
        }
    }
}
